import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

const COLOR_GREEN = '#0BCF97';
const COLOR_ORANGE = '#FC9629';
const COLOR_RED = '#D50046';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class TasksProgressBarComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    return (
      <Container className="kanbanProgressBar" style={{ height: `${this.props.height || 4}px` }}>
        {this.renderBar()}
      </Container>
    );
  }

  renderBar() {
    let p = this.props.progress;
    if (p === undefined) return <Bar progress={-1} height={this.props.height} width={this.props.width} />;
    if (p == -1) return <Bar progress={1} height={this.props.height} width={this.props.width} />;
    return <Bar progress={p} height={this.props.height} width={this.props.width} />;
  }
}

TasksProgressBarComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const TasksProgressBar = compose(
  withConnect,
  withRouter,
)(TasksProgressBarComp);

function Bar(props) {
  const maxWidth = props.width || 127;
  let innerWidth = Math.ceil((props.progress || 0) * maxWidth);

  if (props.progress !== undefined) innerWidth = Math.max(innerWidth, 5);

  let color = COLOR_GREEN;

  const height = props.height || 4;

  if (props.progress < 0.7) color = COLOR_ORANGE;
  if (props.progress < 0.3) color = COLOR_RED;
  if (props.progress == -1) color = '#eff2f7';

  return (
    <div
      style={{
        width: `${maxWidth}px`,
        backgroundColor: '#fff',
        height: height + 'px',
        display: 'inline-block',
        borderRadius: Math.floor(height / 2) + 'px',
        overflow: 'hidden',
        position: 'absolute',
      }}
    >
      <div
        style={{
          width: innerWidth + 'px',
          backgroundColor: color || 'transparent',
          height: height + 'px',
          display: 'inline-block',
          borderRadius: Math.floor(height / 2) + 'px',
          overflow: 'hidden',
          position: 'absolute',
        }}
      ></div>
    </div>
  );
}
